import React, { Component } from 'react';

import Button from '@atlaskit/button/standard-button';
import DropdownMenu, {
  DropdownItem,
  DropdownItemGroup,
} from '@atlaskit/dropdown-menu';
import EditorRemoveIcon from '@atlaskit/icon/glyph/editor/remove';
import MoreIcon from '@atlaskit/icon/glyph/more';

import { messages } from '@qality/common-messages';
import { TestCycle, TestType } from '@qality/common-model';
import {
  StorageOfUniqueServices,
  TestExecutionHelper,
} from '@qality/common-service';
import { DEFAULT_TEST_TYPE } from '@qality/common-utils/src/TestType.const';

import { IssueTestType } from '../molecules/IssueTestType';
import DeleteTestExecutionDialog from './DeleteTestExecutionDialog';
import TestExecutionBreadcrumbs from './TestExecutionBreadcrumbs';
import './_test-execution-header.scss';

type Props = {
  testExecutionName: string;
  testCaseName: string;
  testCaseIssueKey: string;
  testCaseIssueTypeIcon: string;
  testCycle: TestCycle;
  testExecutionId: number;
  testType: TestType;
};

type State = {
  deleteExecutionDialogIsOpen: boolean;
  issueUrl: string;
  testCycleUrl: string;
};

export default class TestExecutionHeader extends Component<Props, State> {
  IS_ADVANCED = StorageOfUniqueServices.get('LicenseService').isAdvanced;

  constructor(props: Props) {
    super(props);
    this.state = {
      deleteExecutionDialogIsOpen: false,
      issueUrl: '',
      testCycleUrl: '',
    };
  }

  async componentDidMount(): Promise<void> {
    const issueUrl = await StorageOfUniqueServices.get(
      'URLService'
    ).getBrowseIssueUrl(this.props.testCaseIssueKey);
    const testCycleUrl = this.props.testCycle
      ? StorageOfUniqueServices.get('URLService').getTestCycleUrl(
          this.props.testCycle.id
        )
      : '';
    this.setState({
      issueUrl,
      testCycleUrl,
    });
  }

  openDialog = (): void => this.setState({ deleteExecutionDialogIsOpen: true });

  closeDialog = (): void =>
    this.setState({ deleteExecutionDialogIsOpen: false });

  deleteExecution = (): void =>
    TestExecutionHelper.deleteTestExecution(
      this.props.testExecutionId,
      this.props.testCaseIssueKey
    );

  render(): React.ReactNode {
    if (this.state.issueUrl) {
      return (
        <div>
          <div className='test-execution-header'>
            <TestExecutionBreadcrumbs
              testCaseIssueKey={this.props.testCaseIssueKey}
              testCaseName={this.props.testCaseName}
              testCaseIssueTypeIcon={this.props.testCaseIssueTypeIcon}
              testCaseUrl={this.state.issueUrl}
              testCycleName={
                this.props.testCycle ? this.props.testCycle.name : null
              }
              testCycleUrl={
                this.props.testCycle ? this.state.testCycleUrl : null
              }
              testType={
                this.IS_ADVANCED ? this.props.testType : DEFAULT_TEST_TYPE
              }
            />
            <div className='test-execution-menu'>
              <DropdownMenu
                shouldFlip={false}
                placement='left-start'
                trigger={({ triggerRef, ...props }) => (
                  <Button
                    {...props}
                    iconBefore={
                      <MoreIcon
                        label={null}
                        size='small'
                        primaryColor='var(--ds-icon, var(--ds-fb-icon))'
                      />
                    }
                    ref={triggerRef}
                    appearance='default'
                  />
                )}
              >
                <DropdownItemGroup>
                  <DropdownItem key='delete' onClick={this.openDialog}>
                    <div className='qality-test-execution-actions-wrapper'>
                      <div className='qality-actions-icon'>
                        <EditorRemoveIcon
                          label={null}
                          primaryColor='var(--ds-icon, var(--ds-fb-icon))'
                        />
                      </div>
                      <div
                        className='qality-actions-label'
                        id='qality-test-case-execution-action-delete'
                      >
                        {messages['testExecution.action.delete']}
                      </div>
                    </div>
                  </DropdownItem>
                </DropdownItemGroup>
              </DropdownMenu>
            </div>
          </div>
          <div className='test_execution_name'>
            {this.props.testExecutionName}
          </div>
          {this.IS_ADVANCED && (
            <IssueTestType
              testType={this.props.testType}
              isReadOnly
              isIconOnly={false}
              isLoading={!this.props.testType}
              customStyle={{ width: 'auto', display: 'inline-block' }}
            />
          )}
          <DeleteTestExecutionDialog
            isOpen={this.state.deleteExecutionDialogIsOpen}
            onCancel={this.closeDialog}
            onDelete={this.deleteExecution}
          />
        </div>
      );
    }
    return null;
  }
}
